import { createMuiTheme } from "@material-ui/core/styles";
export default function ThemeFile(theme) {
  const imp100 = "100% important";
  const inherit = "inherit !important";
  return createMuiTheme({
    custom: {
      loginBgImage: theme.loginBGImage, loginLogo: theme.loginLogo, navbarImage: theme.navbarImage, navbarImageBg: theme.navbarImageBg,
      navbarImageMobile: theme.navbarImageMobile, activeNavLink: theme.activeNavLink, printDetailLogo: theme.printDetailLogo,
      printDetailLink: theme.printDetail, printDetailsQRCode: theme.printDetailsQRCode,
      printDetailsPhoneImage: theme.printDetailsPhoneImage, profilePic: theme.profilePic, userPic: theme.userPic, crmimage: theme.crmimage, defaultDoctorPic: theme.defaultDoctorPic
    },
    palette: {
      common: { black: "#000", white: "#fff" },
      background: { paper: "#fff", default: "#fff" },
      secondary: { main: theme.secondaryColor, },
      primary: {
        dark: "", main: theme.primaryColor,
      },
      thirdColor: { main: theme.thirdColor },
      fourthColor: { main: theme.fourthColor },
      hoverPrimaryColor: { main: theme.hoverPrimaryColor },
      hoverSecondaryColor: { main: theme.hoverSecondaryColor },
      hoverThirdColor: { main: theme.hoverThirdColor },
      hoverFourthColor: { main: theme.hoverFourthColor },
      border: {primaryBorder: theme.primaryBorder, secondaryBorder: theme.secondaryBorder, thirdBorder: theme.thirdBorder,
      fourthBorder: theme.fourthBorder,hoverPrimaryBorder: theme.hoverPrimaryBorder, hoverSecondaryBorder: theme.hoverSecondaryBorder,
      hoverThirdBorder: theme.hoverThirdBorder, hoverFourthBorder: theme.hoverFourthBorder},
      error: { light: "#e57373", main: "#f44336", dark: "#d32f2f", contrastText: "#fff" },
      text: {
        textPrimaryColor: theme.textPrimaryColor, textSecondaryColor: theme.textSecondaryColor, textThirdColor: theme.textThirdColor,
        textFourthColor: theme.textFourthColor, hoverTextPrimaryColor: theme.hoverTextPrimaryColor,
        hoverTextSecondaryColor: theme.hoverTextSecondaryColor, hoverTextThirdColor: theme.hoverTextThirdColor,
        hoverTextFourthColor: theme.hoverTextFourthColor, primary: "#515974", secondary: "#515974", third: "#fff",
        disabled: "rgba(0, 0, 0, 0.38)", hint: "rgba(0, 0, 0, 0.38)", title: theme.titleClr, unauthFontClr: theme.unauthFontClr, printButtonColor: theme.printButtonColor
      },
      minWidthMenu: { minWidthMenu: theme.minWidthMenu },
      logbook: { logbookFasting: theme.logbookFasting, logbookNonFasting: theme.logbookNonFasting, logbookInsulin: theme.logbookInsulin, viewcoworker: theme.viewcoworker },
      graph: { bgcolor: theme.bgcolor, med1GraphStartColor: theme.med1GraphStartColor, med1Color: theme.med1Color, med1GraphEndColor: theme.med1GraphEndColor },
      logo: { logoSize: theme.logoSize }
    },
    typography: {
      useNextVariants: true, fontFamily: "'Roboto', 'Helvicta','Arial',sans-serif",
      button: { textTransform: "inherit" }
    },
    overrides: {
      MUIDataTableFilter: {
        checkboxFormControlLabel: { marginLeft: "0px", marginRight: "15px" },
        resetLink: { marginLeft: "0px" },
        root: { paddingLeft: "10px", paddingTop: "15px" }
      },
      MUIDataTablePagination: {
        root: { borderBottom: "none !important" }
      },
      MuiFilledInput: {
        root: {
          backgroundColor: "#f4f5f5",
          '&:hover': { backgroundColor: "#f4f5f5", }
        }
      },
      MUIDataTable:
      {
        responsiveScroll: { maxHeight: imp100, minHeight: 400 }
      },
      MuiTableFooter: {
        root: { background: "#f8f8f8 !important" }
      },
      MUIDataTableHeadCell: {
        root: { color: "rgba(115, 115, 115, 1)", fontWeight: "bolder", background: "#f9fafa !important", padding: "20px 25px 19.5px 28px" },
        sortActive: { color: "#000" }
      },
      MUIDataTableToolbar: {
        root: { color: theme.titleClr, },
        titleText: { color: theme.titleClr }
      },
      PrivateNotchedOutline: {
        legend: { width: inherit }
      },
      MuiButtonBase: {
        root: { whiteSpace: "nowrap" }
      },
      MuiTableCell:
      {
        root: { "padding": "4px 25px 4px 28px" },
      },
      MuiInputBase: {
        input: { height: "inherit", padding: "10px 0 7px" }
      },
      MuiGridListTile: {
        root: { width: imp100, height: inherit }
      },
      MuiFormGroup: {
        root: { display: "inherit" }
      },
      MuiStepConnector: {
        active: { background: "rgba(34, 98, 191, 1)", width: "3.3px", marginLeft: 11 },
        completed: { background: "rgba(34, 98, 191, 1)", width: "3.3px", height: 50 },
        vertical: { padding: "0" },
        lineVertical: { borderColor: "#429ed5", minHeight: 50 }
      },
      MuiStepIcon: {
        text: { fill: "#fff" }
      },
      MuiStepLabel: {
        label: { paddingLeft: 20 },
        iconContainer: { paddingRight: "0px" },
        active: {
          color: "rgba(34, 98, 191, 1) !important"
        },
        completed: {
          color: "rgba(218, 223, 224, 1) !important"
        }
      },
      MuiOutlinedInput: {
        input: { padding: "7px 8px" }
      },
      MuiDialog: {
        paperScrollPaper: { maxHeight: inherit },
        paperFullWidth: { width: imp100, margin: "0px !important" },
        root: {
          padding: "16px 16px 45px !important"
        }
      },
      MuiPaper: {
        root: { overflow: "visible !important", }
      },
      MuiFormHelperText: {
        root: { minHeight: 0 }
      },
      MuiDialogContent: {
        root: { padding: 0 }
      }
    }
  });
}